import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "question-detail-container"
};
const _hoisted_2 = {
  class: "pairs-matching-container"
};
const _hoisted_3 = {
  class: "pair-row"
};
const _hoisted_4 = {
  key: 0,
  class: "pair-item-container"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  key: 0,
  class: "pair-item-label"
};
const _hoisted_7 = {
  key: 1,
  class: "pair-item-container"
};
const _hoisted_8 = {
  class: "pair-item-label"
};
const _hoisted_9 = {
  class: "matching-icon-container"
};
const _hoisted_10 = {
  class: "pair-item-response"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "selected-answer-label"
};
const _hoisted_13 = {
  key: 1,
  class: "matching-answer-placeholder"
};
const _hoisted_14 = {
  class: "pair-response-option-container"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  class: "pair-response-option-label"
};
const _hoisted_17 = {
  key: 0,
  class: "matching-response-correction"
};
const _hoisted_18 = {
  key: 0,
  class: "matching-response-correction-image-container"
};
const _hoisted_19 = ["src"];
const _hoisted_20 = {
  key: 0,
  class: "matching-response-correction-image-label"
};
const _hoisted_21 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_quiz_question_label = _resolveComponent("quiz-question-label");
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  const _component_quiz_answers_validation_alert = _resolveComponent("quiz-answers-validation-alert");
  const _component_quiz_question_correction_explanation = _resolveComponent("quiz-question-correction-explanation");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['quiz-pairs-matching-question-container', {
      'result-mode': _ctx.isResultMode
    }])
  }, [_ctx.displayOverallVerdictIcon ? (_openBlock(), _createBlock(_component_icon, {
    key: 0,
    icon: _ctx.overallAnswersVerdictIcon,
    class: _normalizeClass(['question-overall-verdict-icon', _ctx.overallVerdictIconClass])
  }, null, 8, ["icon", "class"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [_createVNode(_component_quiz_question_label, {
    label: _ctx.questionCustomLabel || _ctx.question.label,
    "label-detail": _ctx.question?.information
  }, null, 8, ["label", "label-detail"]), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.matchingPairs, pair => {
    return _openBlock(), _createElementBlock("div", _hoisted_3, [pair.itemImage ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("img", {
      class: "pair-item-image",
      src: pair.itemImage.imagePath
    }, null, 8, _hoisted_5), pair.itemImage.imageLabel ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(pair.itemImage.imageLabel), 1)) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(pair.item), 1)])), _createElementVNode("span", _hoisted_9, [_createVNode(_component_icon, {
      class: "matching-icon",
      icon: "ray-start-end"
    })]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_dropdown, {
      trigger: "click",
      placement: "bottom-start",
      "popper-class": "pair-item-response-dropdown",
      disabled: _ctx.isResultMode
    }, {
      dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pairItemResponseOptions, responseOption => {
          return _openBlock(), _createBlock(_component_el_dropdown_item, {
            disabled: responseOption.disabled,
            onClick: $event => _ctx.onPairMatchingAnswerChange(pair, responseOption)
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [responseOption.pair.itemResponseImage ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "pair-response-option-image",
              src: responseOption.pair.itemResponseImage.imagePath
            }, null, 8, _hoisted_15)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_16, _toDisplayString(responseOption.pair.itemResponseImage?.imageLabel || responseOption.pair.itemResponse), 1)])]),
            _: 2
          }, 1032, ["disabled", "onClick"]);
        }), 256))]),
        _: 2
      }, 1024)]),
      default: _withCtx(() => [_createElementVNode("div", {
        class: _normalizeClass(['response-selected-value-container', _ctx.answerStatusClass(_ctx.pairAnswer(pair))])
      }, [_createElementVNode("div", {
        class: _normalizeClass(['selected-answer-content-block', {
          'is-not-empty': _ctx.pairAnswer(pair)
        }])
      }, [_ctx.pairAnswer(pair) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_ctx.pairAnswer(pair).itemResponseImage ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: "selected-answer-image",
        src: _ctx.pairAnswer(pair).itemResponseImage.imagePath
      }, null, 8, _hoisted_11)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.pairAnswer(pair).itemResponseImage?.imageLabel || _ctx.pairAnswer(pair).itemResponse), 1)], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t('view.speach.quiz.question.matching.itemResponsePlaceholder')), 1)), _createVNode(_component_icon, {
        icon: "chevron-down",
        class: "dropdown-toggle-icon"
      }), _createVNode(_component_icon, {
        icon: "close-circle-outline",
        class: "dropdown-delete-icon",
        onClick: _withModifiers($event => _ctx.onPairMatchingClear(pair), ["stop"])
      }, null, 8, ["onClick"]), _ctx.isResultMode ? (_openBlock(), _createBlock(_component_icon, {
        key: 2,
        class: _normalizeClass(['answer-status-icon', _ctx.answerStatusClass(_ctx.pairAnswer(pair))]),
        icon: _ctx.answerStatusIcon(_ctx.pairAnswer(pair))
      }, null, 8, ["class", "icon"])) : _createCommentVNode("", true)], 2)], 2)]),
      _: 2
    }, 1032, ["disabled"]), _ctx.shouldDisplayPairMatchingCorrection(pair) ? (_openBlock(), _createElementBlock("div", _hoisted_17, [pair.itemResponseImage ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("img", {
      class: "matching-response-correction-image",
      src: pair.itemResponseImage.imagePath
    }, null, 8, _hoisted_19), pair.itemResponseImage.imageLabel ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(pair.itemResponseImage.imageLabel), 1)) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(pair.itemResponse), 1))])) : _createCommentVNode("", true)])]);
  }), 256))]), _ctx.displayAnswersValidationAlert ? (_openBlock(), _createBlock(_component_quiz_answers_validation_alert, {
    key: 0,
    question: _ctx.question,
    class: "answers-validation-block",
    "answers-validation-state": _ctx.answersValidationState
  }, null, 8, ["question", "answers-validation-state"])) : _createCommentVNode("", true), _ctx.isResultMode && _ctx.question.correction ? (_openBlock(), _createBlock(_component_quiz_question_correction_explanation, {
    key: 1,
    class: "correction-explanation-block",
    "question-correction": _ctx.question.correction
  }, null, 8, ["question-correction"])) : _createCommentVNode("", true)])], 2);
}